<template>
  <div class="dom">
    <div class="panel">
      <div id="panel-one"></div>
      <div id="panel-two"></div>
      <!-- <div id="panel-three"></div> -->
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import {
  selectStore,
  slectStoreData,
  slectStoreMoneyData,
} from "@/services/store";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent,
  GridComponent,
  ToolboxComponent,
} from "echarts/components";
import { PieChart, LineChart } from "echarts/charts";
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
import { UniversalTransition } from "echarts/features";
import { BarChart } from "echarts/charts";
echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
  DatasetComponent,
  GridComponent,
  BarChart,
  ToolboxComponent,
  LineChart,
  UniversalTransition,
]);
export default {
  data() {
    return {
      /* 扇形图配置 */
      option1: {
        title: {
          // text: "扇形图",
          subtext: "订单金额",
          left: "center",
        },
        color: ["#5b7bda", "#92cc76", "#fac858", "#73c0de", "#ef6666"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "订单金额",
            type: "pie",
            radius: "50%",
            data: [
              // { value: 1048, name: "门店1" },
              // { value: 735, name: "门店2" },
              // { value: 580, name: "门店3" },
              // { value: 484, name: "门店4" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      /* 柱形图配置 */
      option2: {
        legend: {},
        tooltip: {},
        dataset: {
          dimensions: ["product", "充值金额"],
          // dimensions: ["product", "今日充值金额", "2016", "2017"],
          source: [
            // { product: "门店1", 今日充值金额: 104 },
            // { product: "门店2", 今日充值金额: 78 },
            // { product: "门店3", 今日充值金额: 58 },
            // { product: "门店4", 今日充值金额: 48 },
          ],
        },
        xAxis: { type: "category" },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        // series: [{ type: "bar" }, { type: "bar" }, { type: "bar" }],
        series: [
          {
            type: "bar",
            color: ["#ef6666", "#5b7bda", "#92cc76", "#fac858", "#73c0de"], //设置同一类柱子不同颜色
            //设置柱子的宽度
            // barWidth: 30,
            //配置样式
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function(params) {
                  var colorList = ["#5b7bda", "#92cc76", "#fac858", "#73c0de"];
                  return colorList[params.dataIndex];
                },
              },
              //鼠标悬停时：
              // emphasis: {
              //   shadowBlur: 10,
              //   shadowOffsetX: 0,
              //   shadowColor: "rgba(0, 0, 0, 0.5)",
              // },
            },
          },
        ],
      },
      /* 折线图 */
      option3: {
        title: {
          text: "Stacked Line",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "Email",
            type: "line",
            stack: "Total",
            data: [120, 132, 101, 134, 90, 230, 210],
          },
          {
            name: "Union Ads",
            type: "line",
            stack: "Total",
            data: [220, 182, 191, 234, 290, 330, 310],
          },
          {
            name: "Video Ads",
            type: "line",
            stack: "Total",
            data: [150, 232, 201, 154, 190, 330, 410],
          },
          {
            name: "Direct",
            type: "line",
            stack: "Total",
            data: [320, 332, 301, 334, 390, 330, 320],
          },
          {
            name: "Search Engine",
            type: "line",
            stack: "Total",
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
        ],
      },
      //
      form: { storeId: "" },
    };
  },
  async mounted() {
    this.form.storeId = this.$store.state.supUser.storeId;
    let option1 = [];
    let option2 = [];
    let { data } = await selectStore({ storeName: "" }); //所有店铺信息
    if (this.$store.state.supUser.role_id === "0") {
      /* 店长 */
      let storeList = data;
      for (let i = 0; i < storeList.length; i++) {
        let { data } = await slectStoreData({
          timeStart: "",
          timeEnd: "",
          storeId: storeList[i].id,
        });
        console.log("data=========", data.count);
        option1.push({ name: storeList[i].storeName, value: data.count });
      }

      for (let j = 0; j < storeList.length; j++) {
        let { data } = await slectStoreMoneyData({
          timeStart: "",
          timeEnd: "",
          storeId: storeList[j].id,
        });
        console.log("data=========", data.count);
        option2.push({ product: storeList[j].storeName, 充值金额: data.count });
      }
    } else {
      console.log("员工==============");
      this.selectStoreList = this.form.storeId?.split(",");
      const storeList = this.selectStoreList?.map((item) => {
        let result = data?.find((value) => {
          console.log(value);
          return value.id == item;
        });
        return result;
      });
      for (let i = 0; i < storeList.length; i++) {
        let { data } = await slectStoreData({
          timeStart: "",
          timeEnd: "",
          storeId: storeList[i].id,
        });
        option1.push({ name: storeList[i].storeName, value: data.count });
      }

       for (let j = 0; j < storeList.length; j++) {
        let { data } = await slectStoreMoneyData({
          timeStart: "",
          timeEnd: "",
          storeId: storeList[j].id,
        });
        option2.push({ product: storeList[j].storeName, 充值金额: data.count });
      }
    }
    
    this.option1.series[0].data = option1;
    this.option2.dataset.source = option2;
    // console.log("option1=========", option1, "option2======", option2);

    /* 扇形图 */
    var chartDom1 = document.getElementById("panel-one");
    var myChart1 = echarts.init(chartDom1);
    this.option1 && myChart1.setOption(this.option1);
    /* 柱状图 */
    var chartDom2 = document.getElementById("panel-two");
    var myChart2 = echarts.init(chartDom2);
    this.option2 && myChart2.setOption(this.option2);
    /* 折线图 */
    // var chartDom3 = document.getElementById("panel-three");
    // var myChart3 = echarts.init(chartDom3);
    // this.option3 && myChart3.setOption(this.option3);
  },
  async created() {},
  methods: {
    selectStore() {
      // 查询用户登陆数据
      this.form.storeId = this.$store.state.supUser.storeId;
      selectStore({ storeName: "" }).then((res) => {
        if (this.$store.state.supUser.role_id === "0") {
          /* 店长 */
          this.storeList = res.data;
          console.log("this.option1.series[0]=====", this.option1.series[0]);
          this.option1.series[0].data = res.data.map((item) => {
            return { product: item.storeName, 今日充值金额: 104 };
          });
          return;
        }
        /* 员工 */
        console.log("this.option1.series[0]=====", this.option1.series[0]);
        this.selectStoreList = this.form.storeId?.split(",");
        this.storeList = this.selectStoreList?.map((item) => {
          let result = res.data?.find((value) => {
            console.log(value);
            return value.id == item;
          });
          return result;
        });
        this.option1.series[0].data = [{ value: 1048, name: "门店1" }];
        console.log("this.storeList", this.storeList);

        slectStoreData({ timeStart: "", timeEnd: "", storeId: 63 }).then(
          (res) => {
            console.log(res);
          }
        );
        console.log(this.storeList);
      });
    },
  },
};
</script>

<style scoped>
.dom {
  width: 100%;
  padding: 20px;
  height: 80vh;
  overflow: hidden;
  overflow-y: auto;
}
.panel {
  padding: 20px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.panel > div {
  padding: 20px;
  width: 500px;
  height: 500px;
}
#panel-three {
  padding: 20px;
  width: 1000px;
  height: 500px;
}
</style>
